import React from "react";

import CardHeaderLabel from "./CardHeaderLabel";
import ActivityIngestionPanel from "../admin/ActivityIngestionPanel";

const AdminGreyDockCard = () => {
  return (
    <div className="flex h-full min-h-0 flex-col text-white">
      <CardHeaderLabel label="Admin" className="text-white" />
      <ActivityIngestionPanel />
    </div>
  );
};

export default AdminGreyDockCard;
